"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/internal_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalOrderService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.order.v1.InternalOrderService
 */
exports.InternalOrderService = {
    typeName: "spwn.order.v1.InternalOrderService",
    methods: {
        /**
         * 口座情報を取得するためのメソッド
         *
         * @generated from rpc spwn.order.v1.InternalOrderService.GetBankAccountByBrandId
         */
        getBankAccountByBrandId: {
            name: "GetBankAccountByBrandId",
            I: internal_service_pb_1.InternalOrderServiceGetBankAccountByBrandIdRequest,
            O: internal_service_pb_1.InternalOrderServiceGetBankAccountByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.order.v1.InternalOrderService.GetOrderById
         */
        getOrderById: {
            name: "GetOrderById",
            I: internal_service_pb_1.InternalOrderServiceGetOrderByIdRequest,
            O: internal_service_pb_1.InternalOrderServiceGetOrderByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map